export const htmlString = "<!-- import {ViewModel} from './widget' -->\n<div data-bind=\"dxLoadPanel: dxLoadPanelOptions\">\n</div>";